// extracted by mini-css-extract-plugin
export default {"container":"CallCenterDeliveryIssues_container__cVKyN"};